import { render } from "./WasteItemReport.vue?vue&type=template&id=159f4b9b"
import script from "./WasteItemReport.vue?vue&type=script&lang=js"
export * from "./WasteItemReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__